import axios from 'axios'

export default class ExternalService {
  static async getBatteries() {
    return await axios.get(`https://www.hybridbatteryswap.com/new/data/batteries_v2.json?v=10`);
  }
}